export const CARD_PAYMENT_TYPE = 'card';
export const ACH_PAYMENT_TYPE = 'ach';